import { articleTagConfig, type ArticleTag } from "@/lib/articleTags";

interface ArticleTagBadgeProps {
  tag: ArticleTag;
  className?: string;
}

const ArticleTagBadge = ({ tag, className = "" }: ArticleTagBadgeProps) => {
  const config = articleTagConfig[tag];
  if (!config) return null;
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider shadow-md ${config.className} ${className}`}
    >
      <Icon className="w-3 h-3" />
      {config.label}
    </span>
  );
};

export default ArticleTagBadge;
